if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const formData = new FormData(this.form);
      const variantId = parseInt(formData.get('id'), 10);
      const scope = this.closest('.product') || this.form || this;
      const rolls = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
      const lengthEl = scope.querySelector('length-based-product');
      const isLengthBased = !!lengthEl;
      let lengthPerRoll = 1;
      if (isLengthBased) {
        if (typeof lengthEl.getLength === 'function') {
          lengthPerRoll = lengthEl.getLength();
        } else {
          const fm = parseFloat(formData.get('length_m'));
          if (Number.isFinite(fm) && fm > 0) lengthPerRoll = fm;
        }
      }
      const totalMeters = Math.max(1, Math.round(lengthPerRoll * rolls));
      const mainQty = isLengthBased ? totalMeters : rolls;

      const properties = {};
      if (isLengthBased) {
        properties['Length (m)'] = String(lengthPerRoll);
        properties['Quantity'] = String(rolls);
      }

      const productGroup = scope.querySelector('product-group');
      if (productGroup) {
        const current = (productGroup.dataset.selectedType || '').split(':');
        if (current.length >= 2) {
          const propKey = (current[0] || '').trim();
          const propVal = (current[1] || '').trim();
          if (propKey) properties[propKey] = propVal;
        }
      }

      const mainItem = { id: variantId, quantity: mainQty };
      let addonItems = [];
      let bundleId = null;

      const addonsEl = !isLengthBased ? (scope.querySelector('product-addons') || null) : null;
      if (addonsEl) {
        const checkedInputs = Array.from(addonsEl.querySelectorAll('.product-addons-input:checked'));
        if (checkedInputs.length) {
          const addonKey = checkedInputs
            .map(el => el.dataset.variantId)
            .filter(Boolean)
            .map(id => parseInt(id, 10))
            .sort((a, b) => a - b)
            .join('-');
          bundleId = `BNDL-${variantId}-${addonKey}`;

          const addonsByCategory = new Map();
          checkedInputs.forEach(inputEl => {
            const categoryWrapper = inputEl.closest('.product-addons-wrapper');
            const categoryTitle = categoryWrapper?.dataset.categoryTitle || 'Options';
            const productTitle = inputEl.dataset.title || 'Addon';
            const qtyPerParent = 1;
            const displayTitle = `${productTitle}${qtyPerParent !== 1 ? ` x ${qtyPerParent}` : ''}`;

            if (!addonsByCategory.has(categoryTitle)) {
              addonsByCategory.set(categoryTitle, []);
            }
            addonsByCategory.get(categoryTitle).push(displayTitle);
          });

          const addonsSummaryParts = [];
          addonsByCategory.forEach((products, categoryTitle) => {
            const productsList = products.join(', ');
            addonsSummaryParts.push(`${categoryTitle}: ${productsList}`);
          });
          const perSetSummary = addonsSummaryParts.join('; ');

          const grouped = {};
          checkedInputs.forEach(el => {
            const wrapper = el.closest('.product-addons-wrapper');
            const catTitle = wrapper ? (wrapper.dataset.categoryTitle || 'Addons') : 'Addons';
            if (!grouped[catTitle]) grouped[catTitle] = [];
            const t = (el.dataset.title || 'Addon').replace(/^:\s*/, '');
            grouped[catTitle].push(t);
          });

          const groupedSummary = Object.entries(grouped).map(([cat, items]) => {
            return `${cat}:::${items.join(';;;')}`;
          }).join('|||');

          properties['_Add-ons summary'] = perSetSummary;
          properties['_add_ons_grouped'] = groupedSummary;
          properties['__bundle_id'] = bundleId;
          properties['__role'] = 'parent';

          mainItem.properties = properties;

          // The same add-on can be picked more than once (e.g. one door for front and rear).
          // Shopify would merge those into one line anyway, so send one item with the real count.
          const addonCounts = new Map();
          checkedInputs.forEach(el => {
            const vId = el.dataset.variantId && String(el.dataset.variantId).trim();
            const isAvailable = (el.dataset.available || 'true').toString() === 'true';
            if (!vId || !isAvailable) return;
            addonCounts.set(vId, (addonCounts.get(vId) || 0) + 1);
          });

          addonItems = Array.from(addonCounts, ([vId, count]) => ({
            id: parseInt(vId, 10),
            quantity: count * rolls,
            properties: {
              '__bundle_id': bundleId,
              '__role': 'child',
              '__parent_variant_id': String(variantId),
              '__qty_per_parent': String(count)
            }
          }));
        }
      } else {
        if (Object.keys(properties).length) mainItem.properties = properties;
      }
      const payload = { items: [mainItem, ...addonItems] };

      if (this.cart) {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      };

      // Length-based products: pre-check the cart and merge into an existing line rather
      // than adding, so any combination of roll quantities stacks correctly.
      if (isLengthBased) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(cart => {
            const existingIndex = cart.items.findIndex(it =>
              it.variant_id === variantId &&
              it.properties &&
              String(it.properties['Length (m)']) === String(lengthPerRoll)
            );
            if (existingIndex !== -1) {
              const existing = cart.items[existingIndex];
              const existingRolls = parseInt(existing.properties['Quantity'] || '1', 10);
              const newTotalRolls = existingRolls + rolls;
              const newTotalMeters = Math.max(1, Math.round(lengthPerRoll * newTotalRolls));

              return fetch(`${routes.cart_change_url}`, {
                ...fetchConfig(),
                body: JSON.stringify({
                  line: existingIndex + 1,
                  quantity: newTotalMeters,
                  properties: {
                    'Length (m)': String(lengthPerRoll),
                    'Quantity': String(newTotalRolls)
                  }
                })
              }).then(r => r.json().then(data => ({ status: r.status, data })));
            }
            return fetch(`${routes.cart_add_url}`, config)
              .then(r => r.json().then(data => ({ status: r.status, data })));
          })
          .then(({ status, data }) => {
            if (status === 422) {
              const errorMessage = data.description || data.errors || data.message;
              if (errorMessage) this.handleErrorMessage(errorMessage);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
            this.error = false;
          })
          .catch(e => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        return;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          return response.json().then((data) => {
            return { status: response.status, data };
          });
        })
        .then(({ status, data: response }) => {
          if (status === 422) {
            const errorMessage = response.description || response.errors || response.message;
            if (errorMessage) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: errorMessage,
                message: errorMessage
              });
              this.handleErrorMessage(errorMessage);
            }

            if (this.cart) {
              this.cart.refreshCartContents().then(() => {
                if (!this.cart.classList.contains('active')) {
                  this.cart.open();
                }
                this.displayCartItemError(response);
              });
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          if (bundleId && response && Array.isArray(response.items)) {
            const group = response.items.filter(it => {
              const p = it.properties || {};
              return p.__bundle_id === bundleId;
            });
            const parent = group.find(it => (it.properties || {}).__role === 'parent');
            const children = group.filter(it => (it.properties || {}).__role === 'child');
            window.CartBundles = window.CartBundles || new Map();
            window.CartBundles.set(bundleId, {
              parentKey: parent?.key || null,
              childKeys: children.map(c => c.key),
              qtyPerParentByChildKey: Object.fromEntries(children.map(c => [c.key, parseInt((c.properties || {}).__qty_per_parent || '1', 10) || 1]))
            });
          }

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    displayCartItemError(response) {
      if (!response) return;

      const formData = new FormData(this.form);
      const variantId = parseInt(formData.get('id'), 10);

      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        const cartItems = cartDrawer.querySelectorAll('[id^="CartDrawer-Item-"]');
        let targetLine = null;

        cartItems.forEach((itemRow) => {
          const quantityInput = itemRow.querySelector(`input[data-quantity-variant-id="${variantId}"]`);
          if (quantityInput) {
            const lineMatch = itemRow.id?.match(/CartDrawer-Item-(\d+)/);
            if (lineMatch) {
              targetLine = parseInt(lineMatch[1], 10);
            }
          }
        });

        if (targetLine) {
          const errorMessage = response.description || response.errors || response.message;
          if (errorMessage) {
            const errorElement = document.getElementById(`CartDrawer-LineItemError-${targetLine}`);
            if (errorElement) {
              const errorText = errorElement.querySelector('.cart-item__error-text');
              if (errorText) {
                errorText.textContent = errorMessage;
                errorElement.style.display = '';
              }
            }
          }
        }
      }, 100);
    }
  });
}

if (!customElements.get('product-addons')) {
  customElements.define('product-addons', class ProductAddons extends HTMLElement {
    constructor() {
      super();

      const rawMoneyFormat = this.dataset.moneyFormat || '';
      try { this.moneyFormatTemplate = JSON.parse(rawMoneyFormat); }
      catch { this.moneyFormatTemplate = rawMoneyFormat || '${{amount}}'; }

      this.categoryWrappers = Array.from(this.querySelectorAll('.product-addons-wrapper'));
      this.addButton = this.querySelector('[data-add-addons]');
      this.totalElement = this.querySelector('[data-total]');
      this.relianceByVariantIds = new Map();
      this.preCheckedRadioMap = new WeakMap();
      this.helpDialog = this.querySelector('[data-addons-help]');
      this.helpFrame = this.querySelector('[data-help-frame]');
      this.drawerHeadingEl = this.helpDialog ? this.helpDialog.querySelector('[data-drawer-heading]') : null;
      this.helpBodyEl = this.querySelector('[data-help-body]');
      this.activeTrigger = null;
      this.buildRelianceIndex();
      this.attachEventListeners();
      this.applyRelianceRules();
      this.unlockNonReliantCategories();
      this.enforceRequiredSelections();
      this.updateAllSelectedSummaries();
      this.updateTotal();
      // In-group reliance logic - not the same as buildRelianceIndex and applyRelianceRules which is reliance between groups
      this.initGroupReliance();
    }

    // Initialise reliance logic for inputs that depend on selections within the same group.
    initGroupReliance() {
      this.categoryWrappers.forEach(categoryWrapper => {
        const groupInputs = Array.from(categoryWrapper.querySelectorAll('.product-addons-input[data-reliant-product-ids]'));
        if (!groupInputs.length) return;
        categoryWrapper.addEventListener('change', () => {
          groupInputs.forEach(inputEl => this.updateGroupReliance(inputEl, categoryWrapper));
        });
        groupInputs.forEach(inputEl => this.updateGroupReliance(inputEl, categoryWrapper));
      });
    }

    // Updates the reliance state of inputs within a group based on their dependencies and current selections.
    updateGroupReliance(inputEl, categoryWrapper) {
      const reliantIds = (inputEl.dataset.reliantProductIds || '').split(',').map(id => id.trim()).filter(Boolean);
      if (!reliantIds.length) {
        this.setReliantState(inputEl, false);
        return;
      }
      const groupInputs = Array.from(categoryWrapper.querySelectorAll('.product-addons-input'));
      // Only disable if there is a matching reliantId present in the group
      const hasMatchingProduct = groupInputs.some(i => reliantIds.includes(i.value));
      if (!hasMatchingProduct) {
        this.setReliantState(inputEl, false);
        return;
      }
      // Now check if any of the reliantIds are selected
      const relianceSatisfied = reliantIds.some(reliantId =>
        groupInputs.some(i => i.value === reliantId && i.checked)
      );
      this.setReliantState(inputEl, !relianceSatisfied);
    }

    // Sets the "reliant" state for a given input element and its wrapper.
    setReliantState(inputEl, isReliant) {
      const wrapper = inputEl.closest('.product-addons-products-wrapper');
      if (!wrapper) return;
      if (isReliant) {
        wrapper.classList.add('is-reliant');
        inputEl.disabled = true;
        inputEl.checked = false;
      } else {
        wrapper.classList.remove('is-reliant');
        inputEl.disabled = false;
      }
    }

    openHelpDrawer({ title, templateId, triggerEl }) {
      if (!this.helpDialog || !this.helpBodyEl) return;
      const tpl = templateId ? this.querySelector(`#${templateId}`) : null;
      if (!tpl || !('content' in tpl)) return;

      this.helpBodyEl.replaceChildren();
      const node = tpl.content.cloneNode(true);
      this.helpBodyEl.appendChild(node);

      if (this.drawerHeadingEl) this.drawerHeadingEl.textContent = title || '';

      this.activeTrigger = triggerEl || null;

      if (typeof this.helpDialog.showModal === 'function') {
        this.helpDialog.showModal();
      } else {
        this.helpDialog.setAttribute('open', '');
      }

      const firstFocusable = this.helpDialog.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      (firstFocusable || this.helpDialog).focus();

      // Initialize addon-tabs inside the help drawer
      const addonTabs = this.helpDialog.querySelector('addon-tabs');
      if (addonTabs && typeof addonTabs.render === 'function') {
        addonTabs.render();
      }
    }

    closeHelpDrawer() {
      if (!this.helpDialog) return;
      if (typeof this.helpDialog.close === 'function') {
        this.helpDialog.close();
      } else {
        this.helpDialog.removeAttribute('open');
      }
      if (this.activeTrigger) {
        this.activeTrigger.focus();
        this.activeTrigger = null;
      }
    }

    wireHelpDialog() {
      if (!this.helpDialog) return;
      this.helpDialog.addEventListener('click', (e) => {
        if (!this.helpFrame) return;
        const isInside = e.composedPath().includes(this.helpFrame);
        if (!isInside) this.closeHelpDrawer();
      });
      this.helpDialog.addEventListener('cancel', () => { });
    }

    getCategoryInputs(categoryWrapper) {
      return Array.from(categoryWrapper.querySelectorAll('.product-addons-input'));
    }
    getEnabledCategoryInputs(categoryWrapper) {
      return this.getCategoryInputs(categoryWrapper).filter(inputEl => !inputEl.disabled);
    }
    getCheckedCategoryInputs(categoryWrapper) {
      return this.getCategoryInputs(categoryWrapper).filter(inputEl => inputEl.checked);
    }
    getSelectionType(categoryWrapper) {
      return categoryWrapper.dataset.selectionType === 'radio' ? 'radio' : 'checkbox';
    }
    isCategoryRequired(categoryWrapper) {
      const requiredVal = (categoryWrapper.dataset.required || '').toString().toLowerCase();
      return requiredVal === 'true' || requiredVal === '1';
    }

    buildRelianceIndex() {
      this.categoryWrappers.forEach(categoryWrapper => {
        const requiredVariantIds = (categoryWrapper.dataset.reliantVariantIds || '').trim();
        if (!requiredVariantIds) return;

        // Split comma-separated IDs and process each one
        const variantIds = requiredVariantIds.split(',').map(id => id.trim()).filter(Boolean);

        variantIds.forEach(variantId => {
          if (!this.relianceByVariantIds.has(variantId)) {
            this.relianceByVariantIds.set(variantId, []);
          }
          this.relianceByVariantIds.get(variantId).push(categoryWrapper);
        });
      });
    }

    getCurrentlySelectedVariantIds() {
      const selectedIds = new Set();
      this.categoryWrappers.forEach(categoryWrapper => {
        this.getCheckedCategoryInputs(categoryWrapper).forEach(inputEl => selectedIds.add(inputEl.dataset.variantId));
      });
      return selectedIds;
    }

    applyRelianceRules(changedVariantId = null) {
      const selectedVariantIds = this.getCurrentlySelectedVariantIds();

      // Which categories must be updated now
      const targetCategories = (changedVariantId && this.relianceByVariantIds.has(changedVariantId)) ? this.relianceByVariantIds.get(changedVariantId) : this.categoryWrappers.filter(categoryWrapper => (categoryWrapper.dataset.reliantVariantIds || '').trim());
      targetCategories.forEach(categoryWrapper => {
        const requiredVariantIds = (categoryWrapper.dataset.reliantVariantIds || '').trim();
        if (!requiredVariantIds) return;

        // Split comma-separated IDs and check if any of them are selected
        const variantIds = requiredVariantIds.split(',').map(id => id.trim()).filter(Boolean);
        const dependencySatisfied = variantIds.some(variantId => selectedVariantIds.has(variantId));

        if (dependencySatisfied) {
          this.enableCategory(categoryWrapper);
          if (this.isCategoryRequired(categoryWrapper) && this.getCheckedCategoryInputs(categoryWrapper).length === 0) {
            this.autoSelectFirstEnabled(categoryWrapper);
          }
        } else {
          this.disableCategory(categoryWrapper, { clear: true });
        }

        this.updateSelectedSummary(categoryWrapper);
      });
    }

    enableCategory(categoryWrapper) {
      categoryWrapper.classList.remove('is-disabled');
      categoryWrapper.removeAttribute('aria-disabled');
      this.getCategoryInputs(categoryWrapper).forEach(inputEl => {
        const isAvailable = (inputEl.dataset.available || 'true').toString() === 'true';
        inputEl.disabled = !isAvailable; // sold-out disabled
      });
    }

    disableCategory(categoryWrapper, { clear = false } = {}) {
      categoryWrapper.classList.add('is-disabled');
      categoryWrapper.setAttribute('aria-disabled', 'true');
      this.getCategoryInputs(categoryWrapper).forEach(inputEl => {
        inputEl.disabled = true;
        if (clear && inputEl.checked) inputEl.checked = false;
      });
    }

    unlockNonReliantCategories() {
      this.categoryWrappers.forEach(categoryWrapper => {
        const dependsOn = (categoryWrapper.dataset.reliantVariantId || '').trim();
        if (dependsOn) return;
        this.getCategoryInputs(categoryWrapper).forEach(inputEl => {
          const isAvailable = (inputEl.dataset.available || 'true').toString() === 'true';
          inputEl.disabled = !isAvailable;
        });
      });
    }

    enforceRequiredSelections() {
      this.categoryWrappers.forEach(categoryWrapper => {
        if (categoryWrapper.classList.contains('is-disabled')) return;
        if (!this.isCategoryRequired(categoryWrapper)) return;
        if (this.getCheckedCategoryInputs(categoryWrapper).length > 0) return;
        this.autoSelectFirstEnabled(categoryWrapper);
      });
    }

    autoSelectFirstEnabled(categoryWrapper) {
      const enabledInputs = this.getEnabledCategoryInputs(categoryWrapper);
      if (enabledInputs.length) enabledInputs[0].checked = true;
    }

    // Category header: selected title + preview image
    updateSelectedSummary(categoryWrapper) {
      const titleElement = categoryWrapper.querySelector('[data-selected-summary]');
      const separatorElement = categoryWrapper.querySelector('.addons-sep');
      const thumbElement = categoryWrapper.querySelector('[data-selected-thumb]');
      if (!titleElement) return;

      const checkedInputs = this.getCheckedCategoryInputs(categoryWrapper);

      if (checkedInputs.length) {
        const firstChecked = checkedInputs[0];
        const selectedTitle = firstChecked.dataset.title.split('[')[0] || '';
        const selectedImg = firstChecked.dataset.image;

        categoryWrapper.classList.add('has-selection');
        titleElement.textContent = selectedTitle;

        if (separatorElement) separatorElement.style.display = '';
        if (thumbElement) {
          // Only show image if we have a valid, non-empty image URL
          if (selectedImg) {
            thumbElement.src = selectedImg;
            thumbElement.alt = selectedTitle;
            thumbElement.hidden = false;
            thumbElement.style.display = '';
          } else {
            // Hide image and clean up attributes when no valid image
            thumbElement.hidden = true;
            thumbElement.style.display = 'none';
            thumbElement.removeAttribute('src');
            thumbElement.alt = '';
          }
        }
      } else {
        categoryWrapper.classList.remove('has-selection');
        titleElement.textContent = '';
        if (separatorElement) separatorElement.style.display = 'none';
        if (thumbElement) {
          thumbElement.hidden = true;
          thumbElement.style.display = 'none';
          thumbElement.removeAttribute('src');
          thumbElement.alt = '';
        }
      }
    }

    updateAllSelectedSummaries() {
      this.categoryWrappers.forEach(wrapperEl => this.updateSelectedSummary(wrapperEl));
    }

    // Add-ons total
    updateTotal() {
      const totalCents = this.categoryWrappers.reduce((sumAcc, categoryWrapper) => {
        const categorySum = this.getCheckedCategoryInputs(categoryWrapper).reduce((acc, inputEl) => {
          return acc + (parseInt(inputEl.dataset.price, 10) || 0);
        }, 0);
        return sumAcc + categorySum;
      }, 0);

      if (this.totalElement) {
        this.totalElement.textContent = this.formatMoney(totalCents, this.moneyFormatTemplate);
      }

      this.dataset.totalCents = String(totalCents);
      this.dispatchEvent(new CustomEvent('addons:total-changed', { detail: { cents: totalCents } }));
    }

    formatMoney(cents, template) {
      const value = cents / 100;
      const tokenRx = /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/;
      const withSeparators = (num, precision = 2, thousands = ',', decimal = '.') => {
        const parts = num.toFixed(precision).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      };

      let out = template || '${{amount}}';
      const match = out.match(tokenRx);
      if (!match) return `${value.toFixed(2)}`;

      switch (match[1]) {
        case 'amount': out = out.replace(match[0], withSeparators(value, 2)); break;
        case 'amount_no_decimals': out = out.replace(match[0], withSeparators(value, 0)); break;
        case 'amount_with_comma_separator': out = out.replace(match[0], withSeparators(value, 2, '.', ',')); break;
        case 'amount_no_decimals_with_comma_separator': out = out.replace(match[0], withSeparators(value, 0, '.', ',')); break;
      }
      return out;
    }

    collectSelectedItems({ quantity = 1 } = {}) {
      const items = [];
      this.categoryWrappers.forEach(categoryWrapper => {
        this.getCheckedCategoryInputs(categoryWrapper).forEach(inputEl => {
          const variantId = inputEl.dataset.variantId && String(inputEl.dataset.variantId).trim();
          const isEnabled = !inputEl.disabled;
          const isAvailable = (inputEl.dataset.available || 'true').toString() === 'true';

          if (!variantId) {
            console.warn('[Addons] skip: missing variantId', inputEl);
            return;
          }
          if (!isEnabled || !isAvailable) {
            console.warn('[Addons] skip: unavailable/disabled', { variantId, title: inputEl.dataset.title });
            return;
          }
          items.push({ id: variantId, quantity });
        });
      });
      return items;
    }

    attachEventListeners() {
      this.wireHelpDialog();
      // Track pre-click checked state for radios
      this.addEventListener('pointerdown', (evt) => {
        const clickedRadio = evt.target.closest('input[type="radio"].product-addons-input');
        const clickedLabel = evt.target.closest('label.product-addons-label');
        const inputFromLabel = clickedLabel ? document.getElementById(clickedLabel.getAttribute('for')) : null;
        const targetInput = clickedRadio || inputFromLabel;
        if (!targetInput) return;
        this.preCheckedRadioMap.set(targetInput, targetInput.checked);
      }, true);

      // Allow radio to be unchecked if clicked again (toggle off)
      this.addEventListener('click', (evt) => {
        const clickedRadio = evt.target.closest('input[type="radio"].product-addons-input');
        const clickedLabel = evt.target.closest('label.product-addons-label');
        const inputFromLabel = clickedLabel ? document.getElementById(clickedLabel.getAttribute('for')) : null;
        const targetInput = clickedRadio || inputFromLabel;
        if (!targetInput) return;

        const categoryWrapper = targetInput.closest('.product-addons-wrapper');

        if (!categoryWrapper) return;

        // Only allow unchecking if not required
        if (this.getSelectionType(categoryWrapper) === 'radio' && !this.isCategoryRequired(categoryWrapper)) {
          const wasCheckedBeforeClick = this.preCheckedRadioMap.get(targetInput) === true;
          if (wasCheckedBeforeClick) {
            evt.preventDefault();
            targetInput.checked = false;
            targetInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      this.addEventListener('click', (evt) => {
        // Handle label click
        const clickedLabel = evt.target.closest('label.product-addons-label');
        if (clickedLabel) {
          const boundInput = document.getElementById(clickedLabel.getAttribute('for'));
          if (boundInput && boundInput.disabled) {
            evt.preventDefault();
            const isSoldOut = (boundInput.dataset.available || 'true').toString() !== 'true';
            if (isSoldOut) return;
          }
          return;
        }

        // Handle .product-addons-button click
        const clickedButton = evt.target.closest('.product-addons-button');
        if (clickedButton) {
          const inputId = clickedButton.getAttribute('data-for') || clickedButton.getAttribute('for');
          const boundInput = inputId ? document.getElementById(inputId) : null;
          if (!boundInput) return;
          if (boundInput.disabled) {
            evt.preventDefault();
            return;
          }
          // Toggle selection for checkbox or radio
          if (boundInput.type === 'checkbox') {
            boundInput.checked = !boundInput.checked;
            boundInput.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (boundInput.type === 'radio') {
            if (boundInput.checked) {
              // Only allow unchecking if not required
              const categoryWrapper = boundInput.closest('.product-addons-wrapper');
              if (categoryWrapper && !this.isCategoryRequired(categoryWrapper)) {
                boundInput.checked = false;
                boundInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else {
              boundInput.checked = true;
              boundInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });

      this.addEventListener('click', (evt) => {
        const productCard = evt.target.closest('.product-addons-products-wrapper');
        if (!productCard) return;

        const categoryWrapper = productCard.closest('.product-addons-wrapper');
        if (!categoryWrapper || categoryWrapper.classList.contains('is-disabled')) return;

        const inputEl = productCard.querySelector('.product-addons-input');
        if (!inputEl || inputEl.disabled) return;

        // Prevent toggling if clicking on a label or the input itself (let their own handlers work)
        const clickedLabel = evt.target.closest('label');
        if ((clickedLabel && clickedLabel.getAttribute('for') === inputEl.id) || evt.target === inputEl) return;

        // Toggle selection for checkbox or radio
        if (inputEl.type === 'checkbox') {
          inputEl.checked = !inputEl.checked;
          inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (inputEl.type === 'radio') {
          if (inputEl.checked) {
            if (!this.isCategoryRequired(categoryWrapper)) {
              inputEl.checked = false;
              inputEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            inputEl.checked = true;
            inputEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      this.addEventListener('change', (evt) => {
        const inputEl = evt.target.closest('.product-addons-input');
        if (!inputEl) return;

        const categoryWrapper = inputEl.closest('.product-addons-wrapper');

        const changedVariantId = inputEl.dataset.variantId;
        if (changedVariantId) {
          this.applyRelianceRules(changedVariantId);
          this.enforceRequiredSelections();
        }

        this.updateSelectedSummary(categoryWrapper);
        this.updateTotal();
      });

      this.addEventListener('click', (evt) => {
        const trigger = evt.target.closest('[data-help-open]');
        if (!trigger) return;

        const categoryWrapper = trigger.closest('.product-addons-wrapper');
        const title = trigger.getAttribute('data-drawer-heading') || categoryWrapper?.dataset.categoryTitle || '';
        const tplId = trigger.getAttribute('data-help-tpl-id');

        this.openHelpDrawer({ title, templateId: tplId, triggerEl: trigger });
      });
    }
  });
}

if (!customElements.get('atc-total')) {
  customElements.define('atc-total', class AtcTotal extends HTMLElement {
    constructor() {
      super();
      this.onVariantChanged = this.render.bind(this);
      this.onLengthChanged = this.render.bind(this);
      this.onAddonsTotalChanged = this.render.bind(this);
    }

    connectedCallback() {
      this.scope = this.closest('.product') || document;
      this.priceScopeEl = this.closest('.atc-price-wrap') || this.scope;
      this.unitPriceEl = this.priceScopeEl.querySelector('.product-variant-price') || this.scope.querySelector('.product-variant-price');
      this.quantityInput = this.scope.querySelector('input[name="quantity"]');
      this.lengthEl = this.scope.querySelector('length-based-product');
      this.addonsElement = this.scope.querySelector('product-addons');
      this.render();

      document.addEventListener('change', this.onDocumentChange);
      document.addEventListener('variant:changed', this.onVariantChanged);
      if (this.lengthEl) this.lengthEl.addEventListener('length:changed', this.onLengthChanged);
      if (this.addonsElement) this.addonsElement.addEventListener('addons:total-changed', this.onAddonsTotalChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onDocumentChange);
      document.removeEventListener('variant:changed', this.onVariantChanged);
      if (this.lengthEl) this.lengthEl.removeEventListener('length:changed', this.onLengthChanged);
      if (this.addonsElement) this.addonsElement.removeEventListener('addons:total-changed', this.onAddonsTotalChanged);
    }

    onDocumentChange = (evt) => {
      if (evt.target?.name === 'quantity' || evt.target.closest('.product-form__input') || evt.target.closest('.product-addons-wrapper')) {
        this.render();
      }
    };

    getUnitPriceCents() {
      const el = this.unitPriceEl || this.scope.querySelector('.product-variant-price');
      const cents = parseInt(el?.dataset.priceCents || '0', 10);
      return Number.isFinite(cents) ? cents : 0;
    }
    getRolls() {
      const input = this.quantityInput || this.scope.querySelector('input[name="quantity"]');
      const v = parseInt(input?.value || '1', 10);
      return Number.isFinite(v) && v > 0 ? v : 1;
    }
    getLengthPerRoll() {
      if (!this.lengthEl) return 1;
      if (typeof this.lengthEl.getLength === 'function') return this.lengthEl.getLength() || 1;
      const input = this.scope.querySelector('input[name="length_m"]');
      const v = parseFloat(input?.value || '1');
      return Number.isFinite(v) && v > 0 ? v : 1;
    }
    getAddonsTotalCents() {
      if (!this.addonsElement) return 0;
      const cents = parseInt(this.addonsElement.dataset.totalCents || '0', 10);
      return Number.isFinite(cents) ? cents : 0;
    }
    formatNumberWithoutSymbol(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, "{{amount}}");
      }
      const n = cents / 100;
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    render() {
      const unitCents = this.getUnitPriceCents();
      const rolls = this.getRolls();

      let totalCents = 0;

      if (this.lengthEl) {
        const lengthPerRoll = this.getLengthPerRoll();
        totalCents = unitCents * lengthPerRoll * rolls;
      } else {
        const addonsPerSet = this.getAddonsTotalCents();
        totalCents = (unitCents + addonsPerSet) * rolls;
      }

      this.textContent = this.formatNumberWithoutSymbol(totalCents);
    }

    // A helper in your AtcTotal class
    bindAddonsListener() {
      // Remove old listener if it exists
      if (this.addonsElement) {
        this.addonsElement.removeEventListener('addons:total-changed', this.onAddonsTotalChanged);
      }

      // Get the current <product-addons> in the DOM
      this.addonsElement = this.scope.querySelector('product-addons');

      // Attach listener to new element
      if (this.addonsElement) {
        this.addonsElement.addEventListener('addons:total-changed', this.onAddonsTotalChanged);
      }
    }

  });
}

if (!customElements.get('length-unit-toggle')) {
  customElements.define('length-unit-toggle', class LengthUnitToggle extends HTMLElement {
    static FT_PER_M = 3.280839895;
    static M_PER_FT = 0.3048;

    static trimZeros(s) {
      return s.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "").replace(/\.$/, "");
    }
    static formatMeters(m) {
      return LengthUnitToggle.trimZeros(String(Math.ceil(m * 100) / 100));
    }
    static formatFeet(ft) {
      const n = Math.round(ft);
      return Math.abs(ft - n) < 0.01 ? String(n) : LengthUnitToggle.trimZeros(ft.toFixed(2));
    }
    static parseNumber(str) {
      const m = String(str).match(/-?\d+(?:\.\d+)?/);
      return m ? parseFloat(m[0]) : NaN;
    }
    static hintUnit(str) {
      const s = String(str).toLowerCase();
      if (/(ft|feet|′|')/.test(s)) return "ft";
      if (/(m|meter|metre)/.test(s)) return "m";
      return null;
    }

    constructor() {
      super();
      this.fieldset = null;
      this.models = [];
      this.selectedUnit = "m";
      this.defaultUnit = "m";
      this.onClick = this.onClick.bind(this);
      this.selectedOptionEl = document.querySelector('.product-selected-option');
    }

    connectedCallback() {
      this.selectedUnit = (this.dataset.selectedToggle || "m").toLowerCase() === "ft" ? "ft" : "m";
      this.defaultUnit = (this.dataset.default || "m").toLowerCase() === "ft" ? "ft" : "m";
      this.setAttribute("data-selected-toggle", this.selectedUnit);
      this.fieldset = this.closest("fieldset");
      if (!this.fieldset) return;

      // Defer initial collect to ensure labels exist
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.collect();
          this.render();
        });
      });
      this.addEventListener("click", this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
    }

    // Toggle handler
    onClick() {
      this.selectedUnit = this.selectedUnit === "ft" ? "m" : "ft";
      this.setAttribute("data-selected-toggle", this.selectedUnit);
      if (!this.models.length) this.collect();
      this.render();
    }

    // Build model (normalize to meters)
    collect() {
      this.models = [];
      const labels = Array.from(this.fieldset.querySelectorAll("label.variant-radios__label"));
      labels.forEach((labelEl) => {
        const holder = labelEl.querySelector(".label-unit-value");
        if (!holder) return;

        const raw = labelEl.dataset.value ?? holder.textContent;
        const n = LengthUnitToggle.parseNumber(raw);
        if (Number.isNaN(n)) return;

        const hinted = LengthUnitToggle.hintUnit(raw);
        const sourceUnit = hinted || this.defaultUnit;

        const mValue = sourceUnit === "ft" ? n * LengthUnitToggle.M_PER_FT : n;
        this.models.push({ holder, mValue });
      });
    }

    render() {
      const toFeet = this.selectedUnit === "ft";
      for (const { holder, mValue } of this.models) {
        const labelFor = holder.parentElement.getAttribute("for");
        const inputEl = this.fieldset.querySelector(`#${labelFor}`);
        if (toFeet) {
          const ft = mValue * LengthUnitToggle.FT_PER_M;
          holder.textContent = `${LengthUnitToggle.formatFeet(ft)}ft`;
          if (inputEl.checked) {
            this.selectedOptionEl.textContent = `${LengthUnitToggle.formatFeet(ft)}ft`;
          }
        } else {
          holder.textContent = `${LengthUnitToggle.formatMeters(mValue)}m`;
          if (inputEl.checked) {
            this.selectedOptionEl.textContent = `${LengthUnitToggle.formatMeters(mValue)}m`;
          }
        }

      }
    }
  })
}


if (!customElements.get('length-based-product')) {
  customElements.define('length-based-product', class LengthBasedProduct extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[inputmode="numeric"]');
      this.unit = (this.dataset.unit || 'm').toLowerCase();
      this.min = parseFloat(this.dataset.min || '1') || 1;
      this.max = parseFloat(this.dataset.max || '100000') || 100000;
      this.step = parseFloat(this.dataset.step || '1') || 1;

      if (this.input) {
        this.input.min = String(this.min);
        this.input.step = String(this.step);
        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('change', this.onInput);
      }
      this.emitChanged();
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener('input', this.onInput);
        this.input.removeEventListener('change', this.onInput);
      }
    }

    onInput = () => {
      let v = parseFloat(this.input.value);
      if (!Number.isFinite(v)) v = this.min;
      if (v < this.min) v = this.min;
      if (v > this.max) v = this.max;

      const step = this.step;
      v = Math.round(v / step) * step;

      this.emitChanged();
    };

    getLength() {
      const v = parseFloat(this.input?.value || '1');
      return Number.isFinite(v) && v > 0 ? v : 1;
    }

    emitChanged() {
      const lengthPerRoll = this.getLength();
      this.dataset.lengthPerRoll = String(lengthPerRoll);
      this.dispatchEvent(new CustomEvent('length:changed', {
        bubbles: true,
        detail: { lengthPerRoll, unit: this.unit }
      }));
    }
  });
}